import i18next from 'i18next';
import { IFeedbackProps } from './FeedbackBarChart';

export const feedbackChartOptions = (data: IFeedbackProps) => {
  return {
    layout: {
      padding: { top: 40 },
    },
    plugins: {
      datalabels: {
        anchor: 'end' as const,
        align: 'top' as const,
        offset: 5,
        color: '#000',
        font: {
          weight: 'bold' as const,
          size: 14,
        },
        formatter: (value: number) => (value === 0 ? '' : value),
      },
      legend: {
        position: 'bottom' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: '',
            size: 14,
            weight: 500,
          },
          color: '#333',
          padding: 10,
          boxWidth: 8,
          boxHeight: 8,
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context: any) => {
            const label = context.dataset.label || '';
            return `${label}`;
          },
          afterBody: (context: any) => {
            const dataIndex = context[0].dataIndex;
            const category = data?.categories?.[dataIndex];

            if (!category) return [];

            const { ratings, average } = category;

            return [
              '',
              `${i18next.t('average_rating')}: ${average.toFixed(2)}`,
              '',
              `${i18next.t('excellent')}: ${ratings.excellent}`,
              `${i18next.t('good')}: ${ratings.good}`,
              `${i18next.t('normal')}: ${ratings.normal}`,
              `${i18next.t('bad')}: ${ratings.bad}`,
              `${i18next.t('terrible')}: ${ratings.terrible}`,
            ];
          },
        },
        backgroundColor: '#000',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 4,
        padding: 10,
      },
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };
};
